import type { SVGProps } from 'react';

const SvgRanking02 = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 40 54' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M30.0856 16.6031C27.122 14.8596 23.683 13.8428 20 13.8428C16.2187 13.8428 12.6955 14.9157 9.67973 16.7462C3.886 20.2631 0 26.6284 0 33.9214C0 45.0105 8.95436 54.0001 20 54.0001C31.0457 54.0001 40 45.0105 40 33.9214C40 26.5297 36.0099 20.0884 30.0856 16.6031Z'
      fill='white'
    />
    <path
      d='M20.0005 51.7691C29.8189 51.7691 37.7782 43.7785 37.7782 33.9214C37.7782 24.0644 29.8189 16.0737 20.0005 16.0737C10.1821 16.0737 2.22266 24.0644 2.22266 33.9214C2.22266 43.7785 10.1821 51.7691 20.0005 51.7691Z'
      fill='#D2D8DB'
    />
    <path
      d='M20.0003 47.3072C27.3641 47.3072 33.3337 41.3142 33.3337 33.9214C33.3337 26.5287 27.3641 20.5356 20.0003 20.5356C12.6365 20.5356 6.66699 26.5287 6.66699 33.9214C6.66699 41.3142 12.6365 47.3072 20.0003 47.3072Z'
      fill='#B6BCBF'
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.15}
    >
      <path
        d='M20.0003 47.3072C27.3641 47.3072 33.3337 41.3142 33.3337 33.9214C33.3337 26.5287 27.3641 20.5356 20.0003 20.5356C12.6365 20.5356 6.66699 26.5287 6.66699 33.9214C6.66699 41.3142 12.6365 47.3072 20.0003 47.3072Z'
        fill='#BFBFBF'
      />
    </g>
    <path
      d='M20.5827 33.4274C20.9805 33.0149 21.2945 32.6547 21.5259 32.3453C21.7574 32.036 21.9296 31.76 22.0453 31.5131C22.1611 31.2691 22.232 31.0425 22.258 30.8362C22.2826 30.6314 22.2956 30.431 22.2956 30.2378V30.0839C22.2956 29.7091 22.1452 29.3722 21.8443 29.0671C21.5419 28.765 21.0312 28.614 20.3121 28.614C20.0561 28.614 19.8014 28.6401 19.5511 28.691C19.3008 28.7418 19.0535 28.8391 18.8104 28.98C18.5659 29.1223 18.3257 29.3228 18.0885 29.5813C17.8497 29.8384 17.6168 30.1681 17.3853 30.5661L15.5364 29.3489C15.7028 29.0526 15.9111 28.7302 16.1614 28.3816C16.4131 28.033 16.7271 27.7149 17.1061 27.4244C17.4837 27.1354 17.9336 26.8928 18.4545 26.6997C18.9739 26.5065 19.5873 26.4092 20.2933 26.4092C21.076 26.4092 21.7502 26.5065 22.3159 26.6997C22.8801 26.8928 23.346 27.1528 23.712 27.4825C24.078 27.8122 24.3471 28.1913 24.5208 28.6227C24.6944 29.0555 24.7812 29.5087 24.7812 29.9866V30.1797C24.7812 30.9408 24.6104 31.6656 24.2705 32.3555C23.9305 33.044 23.4328 33.7179 22.7774 34.3759L18.6946 38.5139H25.3006V40.5618H15.4785V38.7056L20.5827 33.4274Z'
      fill='white'
    />
    <path
      d='M19.401 4.01916L14.9245 9.63713C14.7399 9.86885 14.4137 9.92919 14.1589 9.77872L8.05118 6.17177C7.59594 5.90291 7.04363 6.31908 7.1736 6.83303L9.48964 15.9914C9.58589 16.372 10.0091 16.5464 10.3512 16.3561C13.2137 14.7641 16.4964 13.8426 20.0007 13.8426C23.4107 13.8426 26.6115 14.7142 29.4194 16.2272C29.7612 16.4114 30.1791 16.2358 30.2746 15.8583L32.557 6.83302C32.687 6.31908 32.1347 5.90291 31.6794 6.17175L25.5716 9.77873C25.3168 9.92919 24.9906 9.86886 24.806 9.63714L20.3294 4.01916C20.0914 3.7205 19.639 3.7205 19.401 4.01916Z'
      fill='#D2D8DB'
    />
    <path
      d='M19.9443 2.69984C20.6869 2.69984 21.289 2.09554 21.289 1.34988C21.289 0.604406 20.6869 0 19.9443 0C19.2017 0 18.5996 0.604406 18.5996 1.34988C18.5996 2.09553 19.2017 2.69984 19.9443 2.69984Z'
      fill='#D2D8DB'
    />
    <path
      d='M33.871 2.19873C33.1283 2.19873 32.5264 2.80314 32.5264 3.54861C32.5264 4.29426 33.1283 4.89857 33.871 4.89857C34.6136 4.89857 35.2157 4.29427 35.2157 3.54861C35.2157 2.80314 34.6136 2.19873 33.871 2.19873Z'
      fill='#D2D8DB'
    />
    <path
      d='M7.47444 3.54861C7.47444 2.80314 6.87238 2.19873 6.12974 2.19873C5.38711 2.19873 4.78516 2.80314 4.78516 3.54861C4.78516 4.29426 5.38709 4.89857 6.12974 4.89857C6.8724 4.89857 7.47444 4.29427 7.47444 3.54861Z'
      fill='#D2D8DB'
    />
    <g
      style={{
        mixBlendMode: 'multiply',
      }}
      opacity={0.2}
    >
      <path
        d='M19.401 4.01916L14.9245 9.63713C14.7399 9.86885 14.4137 9.92919 14.1589 9.77872L8.05118 6.17177C7.59594 5.90291 7.04363 6.31908 7.1736 6.83303L9.48964 15.9914C9.58589 16.372 10.0091 16.5464 10.3512 16.3561C13.2137 14.7641 16.4964 13.8426 20.0007 13.8426C23.4107 13.8426 26.6115 14.7142 29.4194 16.2272C29.7612 16.4114 30.1791 16.2358 30.2746 15.8583L32.557 6.83302C32.687 6.31908 32.1347 5.90291 31.6794 6.17175L25.5716 9.77873C25.3168 9.92919 24.9906 9.86886 24.806 9.63714L20.3294 4.01916C20.0914 3.7205 19.639 3.7205 19.401 4.01916Z'
        fill='#ADADAD'
      />
      <path
        d='M19.9443 2.69984C20.6869 2.69984 21.289 2.09554 21.289 1.34988C21.289 0.604406 20.6869 0 19.9443 0C19.2017 0 18.5996 0.604406 18.5996 1.34988C18.5996 2.09553 19.2017 2.69984 19.9443 2.69984Z'
        fill='#ADADAD'
      />
      <path
        d='M33.871 2.19873C33.1283 2.19873 32.5264 2.80314 32.5264 3.54861C32.5264 4.29426 33.1283 4.89857 33.871 4.89857C34.6136 4.89857 35.2157 4.29427 35.2157 3.54861C35.2157 2.80314 34.6136 2.19873 33.871 2.19873Z'
        fill='#ADADAD'
      />
      <path
        d='M7.47444 3.54861C7.47444 2.80314 6.87238 2.19873 6.12974 2.19873C5.38711 2.19873 4.78516 2.80314 4.78516 3.54861C4.78516 4.29426 5.38709 4.89857 6.12974 4.89857C6.8724 4.89857 7.47444 4.29427 7.47444 3.54861Z'
        fill='#ADADAD'
      />
    </g>
  </svg>
);
export default SvgRanking02;
